import gql from 'graphql-tag'

const statsHomeLineChartAppuntamentiAnno = gql`
  query statsHomeLineChartAppuntamentiAnno {
    statsHomeLineChartAppuntamentiAnno {
      numeroCreati
      numeroConfermatiSegretaria
      numeroConfermatiCliente
      numeroFatti
      mese
      anno
    }
  }
`

export default statsHomeLineChartAppuntamentiAnno


// WEBPACK FOOTER //
// ./src/graphql/queries/statsHomeLineChartAppuntamentiAnno.js